<template>
  <form
    :id="modalId"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    @submit.prevent="onSaved"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="modalClass"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" @click="onClosed">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="item" />
        </div>
        <div class="modal-footer" v-if="hasButtons">
          <button type="submit" class="btn btn-primary">
            {{ $t("button.save") }}
          </button>
          <button type="button" class="btn btn-secondary" @click="onClosed">
            {{ $t("button.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    isShow: false,
    title: String,
    modalId: {
      type: String,
      default: "itemModal",
    },
    modalClass: String,
    hasButtons: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    isShow(value) {
      if (value) {
        $(`#${this.modalId}`).modal("toggle");
        window.onbeforeunload = () => {
          return true;
        };
      } else {
        $(`#${this.modalId}`).modal("toggle");
        window.onbeforeunload = null;
      }
    },
  },
  methods: {
    onSaved() {
      this.$emit("onSaved");
    },
    onClosed() {
      this.$emit("onClosed");
    },
  },
};
</script>
